
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

export default function JobsSection() {
  const navigate = useNavigate();

  const jobs = [
    {
      id: 'job-001',
      featured: true,
      badge: { text: 'VIP 채용관', color: 'bg-yellow-500' },
      logo: 'https://public.readdy.ai/ai/img_res/a04714b788bdc7f6c5d1be273e5db14f.jpg',
      position: '바텐더 급구',
      location: '강남',
      experience: '경력무관',
      salary: '협의가능',
    },
    {
      id: 'job-002',
      featured: false,
      badge: { text: 'TOP', color: 'bg-neon-pink' },
      image: 'https://readdy.ai/api/search-image?query=modern%20upscale%20bar%20interior%20with%20purple%20neon%20lighting%20elegant%20counter%20sophisticated%20nightlife%20atmosphere%20premium%20lounge%20design&width=400&height=240&seq=job-img-1&orientation=landscape',
      position: '홀 매니저',
      location: '역삼',
      experience: '경력 1년',
      salary: '월 350만원',
    },
    {
      id: 'job-003',
      featured: false,
      badge: { text: 'TOP', color: 'bg-neon-pink' },
      image: 'https://readdy.ai/api/search-image?query=stylish%20cocktail%20bar%20setup%20with%20purple%20ambient%20lighting%20premium%20bottles%20display%20modern%20nightclub%20interior%20sophisticated%20venue%20design&width=400&height=240&seq=job-img-2&orientation=squarish',
      position: '서버 모집',
      location: '신사',
      experience: '신입가능',
      salary: '시급 2만원',
    },
  ];

  return (
    <section className="relative py-32 bg-dark-purple">
      <div className="container mx-auto px-20">
        {/* Section Header */}
        <div className="flex items-end justify-between mb-16">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-7xl font-display font-black text-white leading-tight">
              지금 가장 핫한<br />채용 공고
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex flex-col items-end gap-4"
          >
            <p className="text-lg text-gray-400 max-w-sm text-right">
              실시간으로 업데이트되는 프리미엄 포지션
            </p>
            <a
              href="/jobs"
              onClick={(e) => { e.preventDefault(); navigate('/jobs'); }}
              className="inline-flex items-center gap-2 text-sm text-neon-purple hover:text-neon-pink transition-colors cursor-pointer"
            >
              전체 공고 보기
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </motion.div>
        </div>

        {/* Jobs Grid */}
        <div className="grid grid-cols-12 gap-8">
          {jobs.map((job, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`${
                job.featured ? 'col-span-6' : 'col-span-3'
              } group cursor-pointer`}
              data-product-shop
              onClick={() => navigate(`/job/${job.id}`)}
            >
              <div className={`h-full rounded-3xl p-8 ${
                job.featured 
                  ? 'bg-gradient-purple' 
                  : 'bg-white/5 backdrop-blur-md'
              } border border-white/10 hover:border-neon-purple/50 transition-all duration-300`}>
                {/* Badge */}
                <div className={`inline-block ${job.badge.color} text-dark-deep text-xs font-bold px-4 py-2 rounded-lg mb-6`}>
                  {job.badge.text}
                </div>

                {/* Logo or Image */}
                {job.logo ? (
                  <div className="w-20 h-20 mb-6">
                    <img src={job.logo} alt={job.position} className="w-full h-full object-cover rounded-2xl" />
                  </div>
                ) : (
                  <div className="w-full h-48 mb-6">
                    <img src={job.image} alt={job.position} className="w-full h-full object-cover rounded-2xl" />
                  </div>
                )}

                {/* Position */}
                <h3 className={`${job.featured ? 'text-4xl' : 'text-2xl'} font-bold text-white mb-4`}>
                  {job.position}
                </h3>

                {/* Info */}
                <p className="text-base text-gray-400 mb-8">
                  {job.location} · {job.experience} · {job.salary}
                </p>

                {/* Button */}
                <a
                  href={`/job/${job.id}`}
                  onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate(`/job/${job.id}`); }}
                  className={`block w-full h-14 rounded-xl font-semibold transition-all whitespace-nowrap cursor-pointer flex items-center justify-center ${
                    job.featured
                      ? 'bg-neon-purple text-white hover:shadow-neon-purple'
                      : 'border border-white/20 text-white hover:border-neon-purple hover:text-neon-purple'
                  }`}
                >
                  지원하기
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
